__turbopack_context__.v({
  "category-bar": "index-module-scss-module__dU2m9q__category-bar",
  "category-list": "index-module-scss-module__dU2m9q__category-list",
  "category-name": "index-module-scss-module__dU2m9q__category-name",
  "category-row": "index-module-scss-module__dU2m9q__category-row",
  "title": "index-module-scss-module__dU2m9q__title",
});
